import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offer-verified__price-details-container" }

import { ref } from 'vue';
import type { ClientType, TourOperator } from '@/interfaces/common';
import type { MergedOfferItemData, VerifiedFlightSegment, AlternativeFlightsDataArray } from '@interfaces/offer';
import type { HotelCatalogueType } from '@interfaces/hotel-catalogue-types';
import LinkButton from '@lmt-rpb/Atoms/LinkButton/LinkButton.vue';
import OfferVerifiedTravelDetails from './OfferVerifiedTravelDetails.vue';
import OfferVerifiedRoomDetails from './OfferVerifiedRoomDetails.vue';
import OfferVerifiedPriceDetails from './OfferVerifiedPriceDetails.vue';
import { getCatalogInfo } from '@/components/common/services/catalogInfoService';
import OfferVerifiedDivider from './OfferVerifiedDivider.vue';
import { useOfferVerifiedInjection } from '../injectionProps';
import SelectContentAnalytics from '@/js/modules/analytics/SelectContentAnalytics';
import OfferDetailsCatalogueModal from 'src/molecules/OfferDetailsCatalogueModal/OfferDetailsCatalogueModal.vue';
import OfferFlightDetailsModal from 'src/molecules/OfferFlightDetailsModal/OfferFlightDetailsModal.vue';

interface Props {
	offerData: MergedOfferItemData;
	client?: ClientType;
	operator: TourOperator;
	outboundFlightSegments: VerifiedFlightSegment[];
	inboundFlightSegments: VerifiedFlightSegment[];
	ibeCheckoutUrl: string;
	hotelData: {
		Hotel: {
			IffCode: string;
		};
	};
	alternativeFlightsLoading: boolean;
	alternativeFlights: AlternativeFlightsDataArray | boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OfferVerifiedBody',
  props: {
    offerData: {},
    client: { default: 'at' },
    operator: {},
    outboundFlightSegments: {},
    inboundFlightSegments: {},
    ibeCheckoutUrl: {},
    hotelData: {},
    alternativeFlightsLoading: { type: Boolean, default: false },
    alternativeFlights: { type: [Object, Boolean] }
  },
  emits: ['show-alternative-flights', 'verify-offer'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const isCatalogueInfoLoading = ref(true);
const catalogueInfoData = ref<HotelCatalogueType | null>(null);
const operatorCodeMatching = ref(true);
const { isNotAvailable, isVerified, isPackage } = useOfferVerifiedInjection();

const getCatalogueInfo = async (code?: string) => {
	isCatalogueInfoLoading.value = true;

	try {
		const result = await getCatalogInfo(props.offerData, props.hotelData, props.operator, operatorCodeMatching.value, code);
		catalogueInfoData.value = result;
		if (result && !result.OfferCodeMatches) {
			operatorCodeMatching.value = false;
		}
	} catch (error) {
		console.error('Error fetching catalog info:', error);
		catalogueInfoData.value = null;
	} finally {
		isCatalogueInfoLoading.value = false;
	}
};

const flightDetailsAnalytics = () => {
	SelectContentAnalytics.selectContent({
		cId: 'offerlist_verifiedoffer_travel_details',
		cType: 'ux_hotelpage_show_details',
	});
};

const offerDetailsAnalytics = () => {
	SelectContentAnalytics.selectContent({
		cId: 'offerlist_verifiedoffer_offer_details',
		cType: 'ux_hotelpage_show_details',
	});
};

const handleShowHotelInfosClick = () => {
	offerDetailsAnalytics();
	if (!catalogueInfoData.value) {
		getCatalogueInfo();
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["offer-verified__body", { 'offer-verified__body--hotel-only': !_unref(isPackage) }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
				'offer-verified__travel-details-container',
				{
					'offer-verified__travel-details-container-hotel-only': !_unref(isPackage),
				},
			])
    }, [
      _createVNode(OfferVerifiedTravelDetails, {
        "offer-data": _ctx.offerData,
        "outbound-flight-segments": _ctx.outboundFlightSegments,
        "inbound-flight-segments": _ctx.inboundFlightSegments
      }, null, 8 /* PROPS */, ["offer-data", "outbound-flight-segments", "inbound-flight-segments"]),
      _createElementVNode("div", {
        class: _normalizeClass({ 'offer-verified__flight-details-container': _unref(isPackage) && _unref(isVerified) })
      }, [
        (_unref(isPackage) && _unref(isVerified) && !_unref(isNotAvailable))
          ? (_openBlock(), _createBlock(OfferFlightDetailsModal, {
              key: 0,
              class: "offer-verified__flight-details-modal",
              "inbound-flight-segments": _ctx.inboundFlightSegments,
              "outbound-flight-segments": _ctx.outboundFlightSegments,
              onFlightDetailsModalOpen: flightDetailsAnalytics
            }, null, 8 /* PROPS */, ["inbound-flight-segments", "outbound-flight-segments"]))
          : _createCommentVNode("v-if", true),
        (_unref(isPackage) && _unref(isVerified))
          ? _withDirectives((_openBlock(), _createBlock(LinkButton, {
              key: 1,
              label: 'Alternative Flüge',
              "with-icon": true,
              bold: "",
              class: "offer-verified__alternative-flight-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('show-alternative-flights')))
            }, null, 512 /* NEED_PATCH */)), [
              [_vShow, _ctx.alternativeFlights && _unref(isPackage)]
            ])
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */),
    _createVNode(OfferVerifiedDivider),
    _createElementVNode("div", {
      class: _normalizeClass([
				'offer-verified__room-container',
				{
					'offer-verified__room-container-hotel-only': !_unref(isPackage),
				},
			])
    }, [
      _createVNode(OfferVerifiedRoomDetails, {
        "offer-data": _ctx.offerData,
        operator: _ctx.operator
      }, null, 8 /* PROPS */, ["offer-data", "operator"]),
      (_unref(isVerified) && !_unref(isNotAvailable))
        ? (_openBlock(), _createBlock(OfferDetailsCatalogueModal, {
            key: 0,
            "catalogue-info-data": catalogueInfoData.value,
            "is-loading": isCatalogueInfoLoading.value,
            client: _ctx.client,
            class: "offer-verified__catalogue-modal",
            onOperatorChange: getCatalogueInfo,
            onCatalogueModalOpen: handleShowHotelInfosClick
          }, null, 8 /* PROPS */, ["catalogue-info-data", "is-loading", "client"]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createVNode(OfferVerifiedDivider),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(OfferVerifiedPriceDetails, {
        "offer-data": _ctx.offerData,
        client: _ctx.client,
        "ibe-checkout-url": _unref(isVerified) ? _ctx.ibeCheckoutUrl : '',
        onVerifyOffer: _cache[1] || (_cache[1] = ($event: any) => (emit('verify-offer')))
      }, null, 8 /* PROPS */, ["offer-data", "client", "ibe-checkout-url"])
    ])
  ], 2 /* CLASS */))
}
}

})